import styled, { css } from "styled-components";

export const FormContainer = styled.div<{ isLarge?: boolean }>`
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const DoubleButtonWrapper = styled.div<{
  isSingleButton?: boolean;
  fitToText?: boolean;
}>`
  display: ${({ isSingleButton }) => (isSingleButton ? "flex" : "grid")};
  grid-template-columns: 1fr 1.5fr;
  grid-gap: 20px;
  max-width: ${({ isSingleButton }) => (isSingleButton ? "250px" : "350px")};

  ${({ fitToText }) =>
    fitToText &&
    css`
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      max-width: 440px;

      & > button {
        flex: 1 1 auto;
        width: auto;
        white-space: nowrap;
      }
    `}
`;
